<panel *ngIf="!loading">

  <div header><span *ngFor="let path of paths" [ngClass]="{'pointer text-primary': path != group && path.children.length > 1}" (click)="open(path)"><span *ngIf="path != paths[0]" class="hlf-margin-left hlf-margin-right">|</span>{{path.name}}</span></div>

  <div right class="flex row">
    <text-filter *ngIf="!groups.empty" [target]="groups" [placeholder]="'Tìm kiếm'"></text-filter>
    <text-filter *ngIf="groups.empty" [target]="goods" [placeholder]="'Tìm độ dài / cân nặng'"></text-filter>
    <button class="bg-success text-white std-margin-left" (click)="exportExcel()"><i class="fa fa-file-excel"></i></button>
  </div>
  <table responsive class="data hover" *ngIf="!groups.empty">
    <tr>
      <th priority="9" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top text-left"><sortable [target]="groups" [extractor]="groupExtractor('SKU')">Mã hàng</sortable></th>
      <th priority="2" class="text-top text-center"><sortable [target]="groups" [extractor]="groupExtractor('Colors')">Màu</sortable></th>
      <th priority="3" class="text-top text-right"><sortable [target]="groups" [extractor]="groupExtractor('Count')">Tổng có</sortable></th>
      <th priority="6" class="text-top text-right"><sortable [target]="groups" [extractor]="groupExtractor('Quantity')">Tổng có</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="groups" [extractor]="groupExtractor('ExportingCount')">Chờ suất</sortable></th>
      <th priority="7" class="text-top text-right"><sortable [target]="groups" [extractor]="groupExtractor('ExportingQuantity')">Chờ suất</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="groups" [extractor]="groupExtractor('RemainingCount')">Còn lại</sortable></th>
      <th priority="8" class="text-top text-right"><sortable [target]="groups" [extractor]="groupExtractor('RemainingQuantity')" [selected]="true" [sort]="'descending'">Còn lại</sortable></th>
    </tr>
    <tr *ngFor="let i of groups.pageMatches; index as ix" class="pointer" (click)="open(i)">
      <td><small>{{ix + 1 + groups.pageIndex * groups.pageSize}}</small></td>
      <td>
        <good class="text-primary bold spacy" [sku]="i.SKUs[0]"></good>
      </td>
      <td [ngClass]="{'text-right': i.children.length > 0}">
        <span class="text-info bold" *ngIf="i.children.length < 1">{{i.Colors[0]}}</span>
        <ng-container *ngIf="i.children.length > 0"><span>{{i.Colors.length}}</span><unit>{{'màu' | lang}}</unit></ng-container>
      </td>
      <td class="nowrap"><b class="text-info">{{i.LengthCount + i.WeightCount | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit></td>
      <td class="nowrap">
        <div *ngIf="i.LengthQuantity > 0"><span class="text-primary">{{i.LengthQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div *ngIf="i.WeightQuantity > 0"><span class="text-primary">{{i.WeightQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td class="nowrap"><b class="text-danger">{{i.ExportingLengthCount + i.ExportingWeightCount | number : '1.0-0' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">cây</span></td>
      <td class="nowrap">
        <div *ngIf="i.LengthQuantity > 0"><span class="text-danger">{{i.ExportingLengthQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div *ngIf="i.WeightQuantity > 0"><span class="text-danger">{{i.ExportingWeightQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td class="nowrap">
        <b class="text-success">{{i.LengthCount + i.WeightCount - i.ExportingLengthCount - i.ExportingWeightCount | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit>
      </td>
      <td class="nowrap">
        <div *ngIf="i.LengthQuantity > 0"><span class="text-success">{{i.LengthQuantity - i.ExportingLengthQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div *ngIf="i.WeightQuantity > 0"><span class="text-success">{{i.WeightQuantity - i.ExportingWeightQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
    </tr>
    <tr *ngIf="groups.pages.length > 1">
      <td [colSpan]="9" style="z-index: unset; display: table-cell !important" class="text-center"><pagination [target]="groups"></pagination></td>
    </tr>
    <tr class="footer nowrap" *ngIf="groups.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}} ({{groups.matches.length}})</td>
      <td></td>
      <td>
        <div><b>{{sum('Count', groups.matches) | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit></div>
      </td>
      <td>
        <div *ngIf="sum('LengthCount', groups.matches) > 0"><b>{{sum('LengthQuantity', groups.matches) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
        <div *ngIf="sum('WeightCount', groups.matches) > 0"><b>{{sum('WeightQuantity', groups.matches) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
      </td>
      <td>
        <b>{{sum('ExportingCount', groups.matches) | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit>
      </td>
      <td>      
        <div *ngIf="sum('LengthCount', groups.matches) > 0"><b>{{sum('ExportingLengthQuantity', groups.matches) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
        <div *ngIf="sum('WeightCount', groups.matches) > 0"><b>{{sum('ExportingWeightQuantity', groups.matches) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>

      </td>
      <td>
        <b>{{sum('RemainingCount', groups.matches) | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit>
      </td>
      <td>        
        <div *ngIf="sum('LengthCount', groups.matches) > 0"><b>{{sum('RemainingLengthQuantity', groups.matches) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
        <div *ngIf="sum('WeightCount', groups.matches) > 0"><b>{{sum('RemainingWeightQuantity', groups.matches) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
      </td>
    </tr>
  </table>

  <table responsive class="data hover" *ngIf="groups.empty">
    <tr>
      <th priority="8" class="text-top text-right" style="width: 0">STT</th>
      <th priority="5" class="text-top text-left"><sortable [target]="goods" [extractor]="goodExtractor('ImportInvoice')" [selected]="true">Đơn nhập</sortable></th>
      <th priority="3" class="text-top text-center"><sortable [target]="goods" [extractor]="goodExtractor('Vendor')">Nhập từ</sortable></th>
      <th priority="5" class="text-top text-center"><sortable [target]="goods" [extractor]="goodExtractor('Customer')">Xuất tới</sortable></th>
      <th priority="6" class="text-top text-right"><sortable [target]="goods" [extractor]="goodExtractor('State')">Trạng thái</sortable></th>
      <th priority="7" class="text-top text-center"><sortable [target]="goods" [extractor]="goodExtractor('Type')">Loại</sortable></th>
      <th priority="7" class="text-top text-right"><sortable [target]="goods" [extractor]="goodExtractor('OriginalQuantity')">Dài gốc</sortable></th>
      <th priority="7" class="text-top text-right"><sortable [target]="goods" [extractor]="goodExtractor('SplittedQuantity')">Cắt</sortable></th>
      <th priority="1" class="text-top text-right"><sortable [target]="goods" [extractor]="goodExtractor('ActualQuantity')">Dài thực</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="goods" [extractor]="goodExtractor('ReducedQuantity')">Khấu trừ</sortable></th>
      <th priority="1" class="text-top text-right"><sortable [target]="goods" [extractor]="goodExtractor('QuoteQuantity')">Dài tính giá</sortable></th>
      <th priority="7" class="text-top text-right"></th>
    </tr>
    <tr *ngFor="let i of goods.pageMatches; index as ix">
      <td><small>{{ix + 1 + goods.pageSize * goods.pageIndex}}</small></td>
      <td><invoice [id]="i.ImportInvoiceID" [stamp]="i.ImportStamp" [displays]="{stamp:true}" (unconfirmed)="synchronize()"></invoice></td>
      <td class="nowrap uppercase">
        <small class="bold" [ngClass]="{'text-success' : i.VendorID == 1, 'text-warning': i.VendorID > 1, 'text-danger': i.VendorID < 1}">{{partner(i.VendorID)}}</small>
        <div class="bold small" *ngIf="i.VendorID > 1">K{{i.VendorID}}</div>
      </td>
      <td class="nowrap uppercase" [ngClass]="{'text-success' : i.CustomerID > 0, 'text-warning': i.CustomerID == 1, 'text-danger small': i.CustomerID < 1}">{{partner(i.CustomerID)}}</td>
      <td class="nowrap small uppercase" [ngClass]="{'text-danger': i.ExportInvoiceID > 0, 'text-warning': i.ExportInvoiceID < 1}">{{state(i) | lang}}</td>
      <td class="nowrap small uppercase" [ngClass]="{'text-success': i.ParentID < 1, 'text-warning': i.ParentID > 0}">{{type(i) | lang}}</td>
      <td class="nowrap">{{i.ActualQuantity + splitted(i) | number : '1.1-1' : 'en-US'}}<product-unit [type]="i.Unit"></product-unit></td>
      <td class="nowrap">{{splitted(i) | number : '1.1-1' : 'en-US'}}<product-unit [type]="i.Unit"></product-unit></td>
      <td><b class="text-primary">{{i.ActualQuantity | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit></td>
      <td><b class="text-danger">{{i.ActualQuantity - i.ImportQuoteQuantity | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit></td>
      <td><b class="text-danger">{{i.ImportQuoteQuantity | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit></td>
      <td>
        <i class="fa fa-cut text-primary pointer" *ngIf="i.ExportInvoiceID < 1" (click)="split(i)"></i>
      </td>
    </tr>
    <tr *ngIf="goods.pages.length > 1">
      <td [colSpan]="12" class="text-center" style="z-index: unset; display: table-cell !important"><pagination [target]="goods"></pagination></td>
    </tr>
    <tr class="footer nowrap" *ngIf="goods.matches.length > 1">
      <td></td>
      <td><b class="hidden-until-5">{{'TỔNG' | lang}} ({{goods.matches.length}})</b></td>
      <td><b class="hidden-since-5">{{'TỔNG' | lang}} ({{goods.matches.length}})</b></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td>
        <div *ngIf="sum('ActualQuantity', goods.matches, 1) > 0"><b>{{sum('ActualQuantity', goods.matches, 1) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
        <div *ngIf="sum('ActualQuantity', goods.matches, 2) > 0"><b>{{sum('ActualQuantity', goods.matches, 2) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
      </td>
      <td>
        <div *ngIf="sum('ActualQuantity', goods.matches, 1) > 0"><b>{{sum('ReducedQuantity', goods.matches, 1) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
        <div *ngIf="sum('ActualQuantity', goods.matches, 2) > 0"><b>{{sum('ReducedQuantity', goods.matches, 2) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
      </td>
      <td>
        <div *ngIf="sum('ActualQuantity', goods.matches, 1) > 0"><b>{{sum('ImportQuoteQuantity', goods.matches, 1) | number : '1.1-1' : 'en-US'}}</b><m></m></div>
        <div *ngIf="sum('ActualQuantity', goods.matches, 2) > 0"><b>{{sum('ImportQuoteQuantity', goods.matches, 2) | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
      </td>
      <td></td>
    </tr>
  </table>

</panel>

<button *ngIf="!loading && groups.empty && goods.empty" class="text-white bg-success std-margin" style="float: right" (click)="synchronize()"><i class="fa fa-sync"></i></button>

<ngx-loading [show]="loading" [config]="{ fullscreenBackdrop: true}"></ngx-loading>
